import AvaliacaoDesempenho, {
  FinderAvaliacoesDesempenho,
  RetornoAvaliacaoDesempenho,
} from 'Interface/AvaliacoesDesempenho';
import Parametros from 'Interface/Requisicao';
import api from 'Service';

import { paramsParaString } from '../utils';
import { tag as tagVinculosEmpregaticios } from './VinculosEmpregaticios';

export function formData(
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  dados: any,
  metodo: 'POST' | 'PUT' | 'DELETE'
): FormData {
  const formData: FormData = new FormData();

  formData.append('_method', metodo);

  Object.keys(dados).forEach((chave) => {
    if (
      typeof dados[chave] == 'object' &&
      dados[chave] &&
      dados[chave]['_ids']
    ) {
      dados[chave]['_ids'].map((id: string, i: number) => {
        formData.append(`${chave}[_ids][${i}]`, id);
      });
    } else {
      formData.append(chave, dados[chave]);
    }
  });

  if (dados.dados) {
    Object.keys(dados.dados).forEach((chave) => {
      Object.keys(dados.dados[chave]).forEach((chave2) => {
        formData.append(`dados[${chave}][${chave2}]`, dados.dados[chave][chave2]);
      })
    });
  }

  return formData;
}

const tag = 'AvaliacoesDesempenho';

const url = '/avaliacoes-desempenho';

const apiExtendida = api
  .enhanceEndpoints({
    addTagTypes: [tag, tagVinculosEmpregaticios],
  })
  .injectEndpoints({
    endpoints: (construtor) => ({
      recuperarAvaliacoesDesempenho: construtor.query<
        FinderAvaliacoesDesempenho,
        Parametros | void
      >({
        query: (params) => `${url}?${paramsParaString(params)}`,
        providesTags: (resultado) =>
          resultado?.avaliacoes
            ? [
                ...resultado.avaliacoes.map(
                  ({ id }) => ({ type: tag, id } as const)
                ),
                { type: tag, id: 'LISTA' },
              ]
            : [{ type: tag, id: 'LISTA' }],
      }),
      recuperarAvaliacaoDesempenho: construtor.query<
        RetornoAvaliacaoDesempenho,
        string | number | Parametros
      >({
        query: (params) => {
          let id: number;
          let query: Parametros = {};

          if (['string', 'number'].includes(typeof params)) {
            id = params as number;
          } else {
            params = params as Parametros;

            id = params.id as number;
            query = paramsParaString(params);
          }

          return `${url}/${id}?${query}`;
        },
        providesTags: (resultado, erro, params) => {
          let id: number;

          if (['string', 'number'].includes(typeof params)) {
            id = params as number;
          } else {
            params = params as Parametros;

            id = params.id as number;
          }

          return [{ type: tag, id }];
        },
      }),
      adicionarAvaliacaoDesempenho: construtor.mutation<
        RetornoAvaliacaoDesempenho,
        Partial<AvaliacaoDesempenho>
      >({
        query: (dados) => ({
          url: url,
          method: 'POST',
          body: formData(dados, 'POST'),
        }),
        invalidatesTags: (resultado, erro) =>
          !erro
            ? [
                { type: tag, id: 'LISTA' },
                { type: tagVinculosEmpregaticios, id: 'LISTA' },
              ]
            : [],
      }),
      editarAvaliacaoDesempenho: construtor.mutation<
        RetornoAvaliacaoDesempenho,
        Partial<AvaliacaoDesempenho> & Pick<AvaliacaoDesempenho, 'id'>
      >({
        query: ({ id, ...dados }) => ({
          url: `${url}/${id}`,
          method: 'POST',
          body: formData(dados, 'PUT'),
        }),
        invalidatesTags: (resultado, erro, { id }) =>
          !erro
            ? [
                { type: tag, id: 'LISTA' },
                { type: tagVinculosEmpregaticios, id: 'LISTA' },
                { type: tag, id },
              ]
            : [],
      }),
      removerAvaliacaoDesempenho: construtor.mutation<
        RetornoAvaliacaoDesempenho,
        Partial<AvaliacaoDesempenho> & Pick<AvaliacaoDesempenho, 'id'>
      >({
        query: ({ id, ...dados }) => ({
          url: `${url}/${id}`,
          method: 'DELETE',
          body: dados,
        }),
        invalidatesTags: (resultado, erro, { id }) =>
          !erro
            ? [
                { type: tag, id: 'LISTA' },
                { type: tagVinculosEmpregaticios, id: 'LISTA' },
                { type: tag, id },
              ]
            : [],
      }),
    }),
    overrideExisting: false,
  });

export const {
  useRecuperarAvaliacoesDesempenhoQuery,
  useRecuperarAvaliacaoDesempenhoQuery,
  useAdicionarAvaliacaoDesempenhoMutation,
  useEditarAvaliacaoDesempenhoMutation,
  useRemoverAvaliacaoDesempenhoMutation,
} = apiExtendida;
